export var success = function (a) { return ({
    kind: "success",
    value: a,
}); };
export var error = function (err) { return ({
    kind: "error",
    error: err,
}); };
/**
 * @deprecated Use {@link error} instead.
 */
export var err = error;
